"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutFieldResultEndBox = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var layout_box_1 = require("./layout-box");
var LayoutFieldResultEndBox = (function (_super) {
    tslib_1.__extends(LayoutFieldResultEndBox, _super);
    function LayoutFieldResultEndBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LayoutFieldResultEndBox.prototype.getType = function () {
        return layout_box_1.LayoutBoxType.FieldResultEnd;
    };
    LayoutFieldResultEndBox.prototype.clone = function () {
        throw new Error(errors_1.Errors.InternalException);
    };
    LayoutFieldResultEndBox.prototype.isWhitespace = function () {
        throw new Error(errors_1.Errors.InternalException);
    };
    LayoutFieldResultEndBox.prototype.renderGetContent = function (_renderer) {
        throw new Error(errors_1.Errors.InternalException);
    };
    LayoutFieldResultEndBox.prototype.pushInfoForMeasure = function (_info, _showHiddenSymbols) { };
    LayoutFieldResultEndBox.prototype.popInfoForMeasure = function (_info, _showHiddenSymbols) { };
    LayoutFieldResultEndBox.prototype.isLineBreak = function () {
        throw new Error(errors_1.Errors.InternalException);
    };
    return LayoutFieldResultEndBox;
}(layout_box_1.LayoutBox));
exports.LayoutFieldResultEndBox = LayoutFieldResultEndBox;
